export class DeleteReport {
    id:string;
   reason:string;
    
}


// WEBPACK FOOTER //
// ./src/models/deletereport.ts